<template>
  <el-dialog
    v-loading="loading"
    :title="$t('payroll_management_29')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    append-to-body
    width="696px"
    class="staff-wrapper"
  >
    <el-row class="header">
      <el-col class="name">
        <span> {{ $t('payroll_management_31') }}： </span>
        <span>{{ staffDetail.staff_name }}</span>
      </el-col>
      <el-col>
        <span> {{ $t('27') }}： </span>
        <span>{{ staffDetail.department_name }}</span>
      </el-col>
      <el-col>
        <span> {{ $t('1516') }}： </span>
        <span>{{ staffDetail.hire_date }}</span>
      </el-col>
    </el-row>
    <el-form
      v-if="staffDetail.staff_name"
      class="staff-form"
      :model="staffDetail"
      label-position="left"
      ref="staffForm"
    >
      <!-- 调薪生效日期 -->
      <el-form-item
        prop="salary_update_start_date"
        :label="$t('payroll_management_32')"
        key="salary_update_start_date"
        :rules="dateRule"
      >
        <el-date-picker
          class="picker"
          type="date"
          value-format="yyyy-MM-dd"
          v-model="staffDetail.salary_update_start_date"
          :disabled="isEdit('salary_update_start_date')"
          :placeholder="$t('839')"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <div v-for="(arr, ind) in staffDetail.arr" :key="arr.id">
        <h2 class="staff-title">{{ arr.name }}</h2>
        <div v-for="(item, index) in arr.list" :key="item.last.id" class="last-item">
          <el-form-item
            :class="item.later.rule.required ? 'is-required' : ''"
            :label="item.last.name"
            :prop="`arr.${ind}.list.${index}.later.val`"
          >
            <el-input
              disabled
              v-enterNumberPoint2
              v-enterNumberMax="1000000000"
              placeholder="0.00"
              v-model="item.last.val"
            ></el-input>
          </el-form-item>
          <img src="@/assets/img/icon_right.png" alt="" />
          <el-form-item :prop="`arr.${ind}.list.${index}.later.val`" :rules="[item.later.rule]">
            <el-input
              placeholder="0.00"
              v-enterNumberPoint2
              v-enterNumberMax="1000000000"
              v-model="item.later.val"
              :disabled="isEdit('salay')"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <h2 class="staff-title">
        {{ $t('payroll_management_53') }}
        <img src="@/assets/img/icon_tip.png" alt="" />
        <span>{{ $t('payroll_management_54') }}</span>
      </h2>
      <!-- 调薪原因 -->
      <el-form-item
        :label="$t('payroll_management_55')"
        prop="update_reason_type"
        key="update_reason_type"
        :rules="[{ required: true, message: $t('1256'), trigger: 'change' }]"
      >
        <el-select :disabled="isEdit('update_reason_type')" v-model="staffDetail.update_reason_type" class="picker">
          <el-option v-for="(item, key) in reasonTypeList" :key="item" :label="item" :value="key"> </el-option>
        </el-select>
      </el-form-item>
      <!-- 上传附件证明 -->
      <el-form-item :label="$t('payroll_management_56')">
        <el-upload
          class="upload-demo"
          :limit="1"
          :file-list="initFiles"
          :action="uploadUrl"
          :headers="baseHeaders"
          :before-upload="beforeUploadHandle"
          :on-success="successHandle"
          :on-error="errorHandle"
          :on-exceed="exceedHandle"
          :file-format="fileFormat"
          :disabled="isEdit('update_reason_file')"
        >
          <el-button size="small" plain icon="el-icon-upload">{{ $t('728') }}</el-button>
          <p slot="tip" class="el-upload__tip">{{ $t('payroll_management_57') }}</p>
        </el-upload>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item :label="$t('remark')">
        <el-input
          :disabled="isEdit('update_reason_remark')"
          type="textarea"
          :rows="4"
          v-model="staffDetail.update_reason_remark"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <!-- 提交 -->
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="handlerBack">{{ $t('66') }}</el-button>
      <el-button type="primary" :disabled="isDisabled" @click="submitForm">{{ $t('67') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import '../../directive.js'
import rdiff from 'recursive-diff'
import {
  readUpdateSalary,
  saveUpdateSalary,
  saveUpdateLDateLog,
  updateSalaryReasonTypeList,
  getLogDetail,
  getSalaryNotice
} from '@/api/payroll'

import { baseHeaders } from 'util/axios-request'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  components: {},
  props: {
    staffId: String,
    subProjectId: String,
    type: String
  },
  data() {
    const self = this
    return {
      baseHeaders: baseHeaders(),
      row: {},
      uploadUrl: baseURL + '/web/tool/upload_file',
      visible: false,
      loading: true,
      cStaffDetail: {
        salary_update_start_date: '',
        update_reason_type: ''
      },
      staffDetail: {
        salary_update_start_date: '',
        update_reason_type: ''
      },
      initFiles: [],
      reasonTypeList: {},
      fileFormat: ['.pdf', '.jpg', '.png'],
      // 日期选择控制器
      pickerOptions: {
        /**
         *  日期选择器可选范围
         * 上一条有效调薪记录的生效日期-1天~下一条有效调薪记录+1天
         */
        disabledDate(time) {
          const min_date = self.staffDetail.update_min_date
          const max_date = self.staffDetail.update_max_date
          const min = min_date ? new Date(min_date).getTime() - 86400000 : 0
          const max = max_date ? new Date(max_date).getTime() : 0
          if (min && max) return time.getTime() > max || time.getTime() < min
          if (min) return time.getTime() < min - 86400000
          if (max) return time.getTime() > max + 86400000
        }
      },
      dateRule: [
        {
          required: true,
          validator: (rule, value, callback) => {
            const { message } = rule
            if (!value) return callback(new Error(message))
            else if (this.isEffectDate) {
              rule.message = this.$t('i18n.a7edca1c71894b46a8db702b0a0304b9')
              return callback(new Error(message))
            }
            return callback()
          },
          message: this.$t('1256'),
          trigger: 'change'
        }
      ]
    }
  },
  computed: {
    isDisabled() {
      let diff = []
      let diff1 = []
      const arr = this.staffDetail.arr || []
      // 判断出薪资项的数据是否有修改，没有修改不能保存
      diff = rdiff.getDiff(this.cStaffDetail, this.staffDetail)
      if (arr.length) {
        // 判断调薪薪资项是否一致，一致不能点击保存
        const last = []
        const later = []
        arr.forEach(item => {
          item.list.forEach(list => {
            last.push(Number(list.last.val))
            later.push(Number(list.later.val))
          })
        })
        diff1 = rdiff.getDiff(last, later)
      }
      if (diff.length > 0 && diff1.length > 0) return false
      return true
    },
    isEdit() {
      return function (val) {
        if (this.row.statusEdit) {
          if (this.row.statusEdit === 'check') return true
          else {
            const date = new Date().getTime()
            const time = new Date(this.staffDetail.salary_update_start_date).getTime()
            if (this.row.is_cancel && time > date) {
              return false
            } else {
              const arr = [
                'salary_update_start_date',
                'update_reason_file',
                'update_reason_type',
                'update_reason_remark'
              ]
              if (arr.includes(val)) return false
            }
            return true
          }
        }
        return false
      }
    },
    isEffectDate() {
      const data = this.staffDetail.salary_update_start_date || ''
      const cData = this.cStaffDetail.salary_update_start_date || ''
      const effect = this.staffDetail.effect_salary_update_start_date || []
      return data !== cData && effect.includes(data)
    }
  },
  methods: {
    init(row) {
      this.row = row
      this.staffDetail = {}
      this.visible = true
      this.loading = true
      if (row.statusEdit) {
        this.getLogDetail(row)
      } else this.getReadUpdateSalary(row)
      this.getReasonTypeList()
    },
    // 调薪历史详情
    getLogDetail(row) {
      getLogDetail({ staff_info_id: this.$route.params.staff_id, id: row.id }).then(res => {
        this.handleDetail(res.data || {})
      })
    },
    getReadUpdateSalary(row) {
      readUpdateSalary({ staff_id: row.staff_id }).then(res => {
        this.handleDetail(res.data || {})
      })
    },
    handleDetail(data) {
      if (!data.salary && !data.salary.later) return
      const arr = []
      const last = data.salary.last || []
      const later = data.salary.later || []
      last.forEach((lastItem, lastIndex) => {
        arr.push({
          list: [],
          id: lastItem.id,
          name: lastItem.name
        })
        lastItem.list.forEach((item, index) => {
          const laterItem = later[lastIndex].list[index]
          // is_salary_update 为0 取last的值，为1取later 里的值
          // if (Number(data.is_salary_update) !== 1) laterItem.val = item.val
          arr[lastIndex].list.push({
            last: item,
            later: laterItem
          })
        })
      })
      data.arr = arr
      this.staffDetail = data
      this.cStaffDetail = JSON.parse(JSON.stringify(data))
      const update_reason_type = data.update_reason_type
      this.staffDetail.update_reason_type = !update_reason_type || update_reason_type === '0' ? '' : update_reason_type
      const update_reason_file = this.staffDetail.update_reason_file
      this.initFiles = update_reason_file ? [{ name: update_reason_file, url: update_reason_file }] : []
      this.loading = false
    },
    getReasonTypeList() {
      updateSalaryReasonTypeList().then(res => {
        if (res && res.code === 1) {
          this.reasonTypeList = res.data
        }
      })
    },
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      }
    },
    exceedHandle() {
      this.$message.error(
        this.$t('payroll_management_58', {
          fileLimit: 1
        })
      )
    },
    // 上传失败
    // err, file, fileList
    errorHandle(err) {
      this.$message.error('upload error')
      throw err
    },
    // 上传成功+
    successHandle(res, file) {
      const response = res
      const data = response.data
      this.staffDetail.update_reason_file = data.object_url
    },
    handlerBack() {
      this.visible = false
    },
    handleSubmitData() {
      const salary = this.staffDetail.salary
      this.staffDetail.arr.forEach((arr, arrIndex) => {
        const lastList = []
        const laterList = []
        arr.list.forEach(item => {
          lastList.push(item.last)
          laterList.push(item.later)
        })
        salary.last[arrIndex].list = lastList
        salary.later[arrIndex].list = laterList
      })
      const data = {
        update_reason_type: this.staffDetail.update_reason_type,
        update_reason_file: this.staffDetail.update_reason_file,
        update_reason_remark: this.staffDetail.update_reason_remark,
        department_name: this.staffDetail.department_name,
        hire_date: this.staffDetail.hire_date,
        is_salary_update: this.staffDetail.is_salary_update,
        salary_update_start_date: this.staffDetail.salary_update_start_date,
        settlement_type: this.staffDetail.settlement_type,
        staff_code: this.staffDetail.staff_code,
        staff_info_id: this.staffDetail.staff_info_id,
        staff_name: this.staffDetail.staff_name,
        salary
      }
      return data
    },
    // 提交表单
    submitForm() {
      this.$refs.staffForm.validate(valid => {
        if (valid) {
          getSalaryNotice({
            salary_update_start_date: this.staffDetail.salary_update_start_date,
            staff_info_id: this.staffDetail.staff_info_id,
            id: this.staffDetail.id,
            type: '1'
          }).then(res => {
            if (res.data && res.data.is_show) {
              const str = this.cStaffDetail.salary_update_start_date
                ? this.$t('i18n.308988651cb34894b413f04bb5a3928a')
                : this.$t('i18n.871a4c4dc1fe4465a0e1e5a72250d87d')
              this.$confirm(str, this.$t('229'), {
                confirmButtonText: this.$t('131'),
                cancelButtonText: this.$t('66'),
                type: 'warning'
              })
                .then(() => {
                  if (!this.row.statusEdit) this.saveUpdateSalary()
                  else this.saveUpdateLDateLog()
                })
                .catch(() => {})
            } else {
              if (!this.row.statusEdit) this.saveUpdateSalary()
              else this.saveUpdateLDateLog()
            }
          })
        }
      })
    },
    saveUpdateLDateLog() {
      const data = Object.assign({}, this.staffDetail, this.handleSubmitData())
      saveUpdateLDateLog(data).then(res => {
        if (res && res.code === 1) {
          this.$message({
            message: this.$t('886'),
            type: 'success'
          })
          this.visible = false
          this.$emit('save')
        }
      })
    },
    saveUpdateSalary() {
      const data = this.handleSubmitData()
      saveUpdateSalary(data).then(res => {
        if (res && res.code === 1) {
          this.$message({
            message: this.$t('886'),
            type: 'success'
          })
          this.visible = false
          this.$emit('save')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.staff-wrapper {
  /deep/ .el-dialog__body {
    display: flex;
    flex-direction: column;
  }
  .header {
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    .el-col {
      margin-bottom: 5px;
      margin: 10px 0;
      span {
        margin-right: 10px;
      }
    }
    .name {
      font-size: 18px;
      font-weight: bolder;
    }
  }
  .staff-form {
    overflow: auto;
    /deep/ .el-form-item {
      padding: 0 4px;
      width: 100%;
      .el-form-item__content {
        width: 100%;
        display: flex;
        align-items: center;
        .el-input {
          max-width: 288px;
        }
        .picker {
          width: 600px;
          max-width: 600px;
          .el-input {
            max-width: 100%;
          }
        }
      }
    }
    .last-item {
      display: flex;
      align-items: flex-end;
      img {
        width: 16px;
        height: 16px;
        margin: 0 16px 34px;
      }
    }
    .staff-title {
      margin: 0 0 10px 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 400;
      img {
        width: 16px;
        margin: 0 8px;
        vertical-align: middle;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .staff-tip {
      font-size: 12px;
      margin: 14px 0 8px 0;
      color: rgba(0, 0, 0, 0.65);
    }
    .upload-demo {
      width: 100%;
    }
    .el-upload__tip {
      font-size: 14px;
      line-height: 20px;
      margin: 0;
      color: rgba(0, 0, 0, 0.25);
    }
  }
}
</style>
